import { TFunction } from '@lyearn/i18n';
import {
  BookmarkOutline,
  Delete,
  Duplicate,
  ExternalLinkOutline,
  Flip,
  Image,
  SettingsOutlineLegacy,
  Shuffle,
  Text,
} from '@lyearn/icons';

import {
  displayCaptionMenuItem,
  displayCaptionMenuTitle,
  displayConvertImageMenuItem,
  displayConvertImageTitle,
  displayConvertLinkMenuItem,
  displayConvertLinkTitle,
  displayPreviewMenuItem,
  displayPreviewTitle,
  displayReplaceMenuItem,
  displaySettingMenuItem,
  displayTurnIntoMenuItem,
  onConvertImageClick,
  onConvertLinkClick,
  onDeleteClick,
  onDuplicateClick,
  onPreviewClick,
  onReplaceClick,
  onSettingsClick,
  toggleCaption,
  toggleTurnIntoMenu,
} from './utils/actions';

export const menuItems = (t: TFunction, isLocalizedContent: boolean) => {
  if (isLocalizedContent) {
    return [
      {
        name: 'replace',
        title: t('Common:Actions.Replace'),
        icon: Shuffle,
        onItemClick: onReplaceClick,
        isEnabled: displayReplaceMenuItem,
      },
    ];
  }
  return [
    {
      name: 'caption',
      title: displayCaptionMenuTitle(t),
      icon: Text,
      onItemClick: toggleCaption,
      isEnabled: displayCaptionMenuItem,
    },
    {
      name: 'turn_into',
      title: t('Lygo:TurnInto'),
      icon: Flip,
      onItemClick: toggleTurnIntoMenu,
      isEnabled: displayTurnIntoMenuItem,
    },
    {
      name: 'convert_image',
      title: displayConvertImageTitle(t),
      icon: Image,
      onItemClick: onConvertImageClick,
      isEnabled: displayConvertImageMenuItem,
    },
    {
      name: 'replace',
      title: t('Common:Actions.Replace'),
      icon: Shuffle,
      onItemClick: onReplaceClick,
      isEnabled: displayReplaceMenuItem,
    },
    {
      name: 'preview',
      title: displayPreviewTitle(t),
      icon: BookmarkOutline,
      onItemClick: onPreviewClick,
      isEnabled: displayPreviewMenuItem,
    },
    {
      name: 'convert_link',
      title: displayConvertLinkTitle(t),
      icon: ExternalLinkOutline,
      onItemClick: onConvertLinkClick,
      isEnabled: displayConvertLinkMenuItem,
    },
    {
      name: 'duplicate',
      title: t('Common:Actions.Duplicate'),
      icon: Duplicate,
      onItemClick: onDuplicateClick,
      isEnabled: () => true,
    },
    {
      name: 'settings',
      title: t('Common:Actions.Settings'),
      icon: SettingsOutlineLegacy,
      onItemClick: onSettingsClick,
      isEnabled: displaySettingMenuItem,
    },
    {
      divider: true,
      isEnabled: () => true,
    },
    {
      name: 'delete',
      title: t('Common:Actions.Delete'),
      icon: Delete,
      onItemClick: onDeleteClick,
      color: 'text-text-error',
      isEnabled: () => true,
    },
  ];
};

export const BLOCK_MENU_WIDTH = 192;
export const BLOCK_MENU_BUTTON_WIDTH = 36;
export const BLOCK_MENU_BUTTON_HEIGHT = 16;
export const BLOCK_MENU_BUTTON_MARGIN = 16;
export const BLOCK_MENU_ITEM_HEIGHT = 40;
export const BLOCK_MENU_PADDING = 20;
